<template>
  <!--活动满减满赠组件  -->
  <div class="con" @click="showActive">
    <div class="con_pad border_top1px_shadow clearfix">
      <div class="left font12 font_weight400 colo055 color_select">活动</div>
      <img
        src="@/assets/product/icon_free@2x.png"
        alt=""
        class="left icon_free"
      />
      <div class="left font12 font_weight400 colo087 color_select">
        {{ mallretailspu.gift.activityName }}
      </div>
      <img
        src="@/assets/common/icon_back_b87_24@2x.png"
        alt=""
        class="right color_right"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: ""
    };
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  methods: {
    showActive() {
      this.$emit("showActive");
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  background: #fff;
  .con_pad {
    padding: 13px 0 10px;
    margin: 0 10px;
  }
  .color_select {
    line-height: 17px;
    margin: 4px 20px 0 0;
  }
  .color_right {
    width: 24px;
  }
  .icon_free {
    margin: 3px 8px 0 0;
    width: 36px;
  }
}
</style>
